/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingCharacteristics_listing$ref: FragmentReference;
declare export opaque type AggregatesListingCharacteristics_listing$fragmentType: AggregatesListingCharacteristics_listing$ref;
export type AggregatesListingCharacteristics_listing = {|
  +hasBalcony: ?boolean,
  +hasGarden: ?boolean,
  +hasParking: ?boolean,
  +hasElevator: ?boolean,
  +hasView: ?boolean,
  +hasFireplace: ?boolean,
  +hasGarage: ?boolean,
  +isChildFriendly: ?boolean,
  +isWheelchairAccessible: ?boolean,
  +isNewDevelopment: ?boolean,
  +hasLavatoryConnection: ?boolean,
  +hasGasSupply: ?boolean,
  +hasSewerageSupply: ?boolean,
  +hasCellar: ?boolean,
  +hasWaterSupply: ?boolean,
  +hasStorageRoom: ?boolean,
  +hasDishWasher: ?boolean,
  +hasPlayGround: ?boolean,
  +hasVirtualTour: ?boolean,
  +hasRestrooms: ?boolean,
  +hasCableTv: ?boolean,
  +hasWashingMachine: ?boolean,
  +hasTumbleDryer: ?boolean,
  +hasInternet: ?boolean,
  +isGroundfloorRaised: ?boolean,
  +isHighlighted: ?boolean,
  +isAnimalFriendly: ?boolean,
  +isOldBuilding: ?boolean,
  +secondaryResidenceEligible: ?boolean,
  +hasNewBuildingProject: ?boolean,
  +distPublicTransportation: ?number,
  +distShopping: ?number,
  +distKindergarten: ?number,
  +distElementarySchool: ?number,
  +distHighSchool: ?number,
  +distMotorWay: ?number,
  +$refType: AggregatesListingCharacteristics_listing$ref,
|};
export type AggregatesListingCharacteristics_listing$data = AggregatesListingCharacteristics_listing;
export type AggregatesListingCharacteristics_listing$key = {
  +$data?: AggregatesListingCharacteristics_listing$data,
  +$fragmentRefs: AggregatesListingCharacteristics_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingCharacteristics_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBalcony",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasGarden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasParking",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasElevator",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasView",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasFireplace",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasGarage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isChildFriendly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isWheelchairAccessible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNewDevelopment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLavatoryConnection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasGasSupply",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasSewerageSupply",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCellar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWaterSupply",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasStorageRoom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasDishWasher",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPlayGround",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVirtualTour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasRestrooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCableTv",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWashingMachine",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasTumbleDryer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInternet",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGroundfloorRaised",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isHighlighted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAnimalFriendly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOldBuilding",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryResidenceEligible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNewBuildingProject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distPublicTransportation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distShopping",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distKindergarten",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distElementarySchool",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distHighSchool",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "distMotorWay",
      "storageKey": null
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'a79d1601322bb5633edede0e61a2b91c';

export default node;
